import {Component, Inject, OnInit} from '@angular/core';
import {Toast} from '../../shared/toast/toast';
import {IdexService} from '../../idex.service';
import {TranslateService} from '@ngx-translate/core';
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';

declare var $: any;

@Component({
   selector: 'app-advance-search-dialog',
   templateUrl: './advance-search-dialog.component.html',
   styleUrls: ['./advance-search-dialog.component.css']
})
export class AdvanceSearchDialogComponent implements OnInit {
   public itemSearch = {
      taskName: '',
      statusSearch: '',
      emailSender: '',
      emailSigner: '',
      sentDateFrom: '',
      sentDateTo: '',
      lastUpdateFrom: '',
      lastUpdateTo: ''
   };
   public sentDate: any;
   public lastUpdate: any;
   retrievedData: any;

   constructor(public toast: Toast,
               public service: IdexService,
               public translate: TranslateService,
               private dialogRef: MatDialogRef<AdvanceSearchDialogComponent>,
               @Inject(MAT_DIALOG_DATA) public data: any) {
   }

   ngOnInit() {
      this.retrievedData = sessionStorage.getItem('itemSearch');
      if (this.retrievedData !== null) {
         this.itemSearch = JSON.parse(this.retrievedData);
      }
   }

   dropDownSendDateTo() {
      const sent_date_to = $('#sent_date_to').val();
      if (sent_date_to !== '') {
         $('#sent_date').attr('max', sent_date_to);
      }
   }

   dropDownSendDateFrom() {
      const sent_date = $('#sent_date').val();
      if (sent_date !== '') {
         $('#sent_date_to').attr('min', sent_date);
      }
   }

   onPressSendDateTo(val) {
      const sent_date_to = $('#sent_date_to').val();
      if (sent_date_to === '') {
         this.sentDate = val;
      }
   }

   onPressSendDateFrom(val) {
      const sent_date = $('#sent_date').val();
      if (sent_date === '') {
         this.sentDate = val;
      }
   }

   dropDownLastDateTo() {
      const last_update_to = $('#last_update_to').val();
      if (last_update_to !== '') {
         $('#last_update').attr('max', last_update_to);
      }
   }

   dropDownLastDateFrom() {
      const last_update = $('#last_update').val();
      if (last_update !== '') {
         $('#last_update_to').attr('min', last_update);
      }
   }

   onPressLastDateTo(val) {
      const last_update_to = $('#last_update_to').val();
      if (last_update_to === '') {
         this.lastUpdate = val;
      }
   }

   onPressLastDateFrom(val) {
      const last_update = $('#last_update').val();
      if (last_update === '') {
         this.lastUpdate = val;
      }
   }

   onSubmit(taskName, status, emailSender, emailSigner, sentDate, sentDateTo, lastUpdate, lastUpdateTo) {
      if (sentDate === '' && sentDateTo === '') {
         this.translate.get('search_advance.error_sent_date').subscribe(s => {
            this.toast.error(s);
         });
      }  else {
         this.itemSearch.taskName = ((taskName === '') ? '' : taskName.trim());
         this.itemSearch.statusSearch = status;
         this.itemSearch.emailSender = ((emailSender === '') ? '' : emailSender.trim());
         this.itemSearch.emailSigner = ((emailSigner === '') ? '' : emailSigner.trim());
         this.itemSearch.sentDateFrom = sentDate;
         this.itemSearch.sentDateTo = sentDateTo;
         this.itemSearch.lastUpdateFrom = lastUpdate;
         this.itemSearch.lastUpdateTo = lastUpdateTo;

         this.dialogRef.close({result: true, itemSearch: this.itemSearch});
      }

   }

   onClear() {
      $('#form_advanced').find('input[type=text]').val('');
      $('#form_advanced').find('input[type=date]').val('');
      $('select option:contains("All")').prop('selected', true);
      $('select option:contains("ทั้งหมด")').prop('selected', true);
      sessionStorage.removeItem('itemSearch');
   }

}
